import { timeToClockFormat } from '@shared/utils/time';
import { VehicleType } from '../models/vehicleType';
import { formatCountdown } from '@shared/utils/formatCountdown';

export function getArrivalDisplayTime(
  time: number,
  vehicleType: VehicleType,
): string {
  if (vehicleType === 'train') {
    return timeToClockFormat(time);
  }

  const countdown = formatCountdown(time);

  return countdown === 'nu' ? 'Nu' : `${countdown} min`;
}
